const firebaseConfig = {
    apiKey: "AIzaSyBL0kVescCsuODN1pS5-BLALZdtyL9TZl4",
    authDomain: "crypto-hub-i.firebaseapp.com",
    projectId: "crypto-hub-i",
    storageBucket: "crypto-hub-i.appspot.com",
    messagingSenderId: "512063201973",
    appId: "1:512063201973:web:3e063d5886f1a54c65d4fc"
};

export default firebaseConfig;